import React, { PureComponent } from 'react';
import styles from './index.css';
import Slides from '@ifeng-fe/ui_pc_slides';
import { formatImage } from '@ifeng-fe/container_channel/common/client/winter/utils/formatImg';
import errorBoundary from '@ifeng-fe/errorBoundary';
import PropTypes from 'prop-types';

const ImgSlides = errorBoundary(
    class extends PureComponent {
        static propTypes = {
            content: PropTypes.array,
        };
        render() {
            const { content } = this.props;
            const config = {
                arrows: true,
                dots: false,
                dotsAction: 'click',
                autoplay: true,
                autoplayInterval: 6000,
                speed: 1000,
                dotStyle: styles.dot,
                dotCurrentStyle: styles.current,
                unitSize: 778,
            };
            let contnetList = [];

            if (content && content.map) {
                contnetList = content.map(item => ({
                    src: item && item.src ? formatImage(item.src, 778, 450) : '',
                }));
            }

            return (
                <div className={styles.box_b}>
                    <ul className={styles.list1_b}>
                        <Slides config={config} content={content} />
                    </ul>
                </div>
            );
        }
    },
);

export { ImgSlides };
export default ImgSlides;
